import apiService from "service/api";

export const getFamilyMembers = () => {
  return apiService("/family/accounts/members/", "GET", undefined, true);
};

export const deleteFamilyDependant = (accountId: number) => {
  return apiService(
    `/family/accounts/members/${accountId}/`,
    "DELETE",
    null,
    true
  );
};

export const updateFamilyDependant = (accountId: number) => {
  return apiService(
    `/family/accounts/members/${accountId}/`,
    "PUT",
    null,
    true
  );
};
export const addFamilyDependant = (formData: Record<string, any>) => {
  return apiService(`/family/accounts/add_dependent/`, "POST", formData, true);
};

export const getUpcomingVaccinations = () => {
  return apiService(
    "/family/accounts/members/upcoming-vaccinations/",
    "GET",
    undefined,
    true
  );
};

export const getFamilyMemberVaccinationById = (id: number) => {
  return apiService(
    `/family/accounts/members/${id}/vaccinations/`,
    "GET",
    undefined,
    true
  );
};

export const getFamilyDashboard = (member_id: number) => {
  return apiService(
    `/family/accounts/members/${member_id}/dashboard/`,
    "GET",
    undefined,
    true
  );
};
